import { useState, useEffect } from 'react';

export const storage = {
	set: (key, value) => {
		try {
			localStorage.setItem(key, JSON.stringify(value));
		} catch (error) {
			console.error('Помилка при збереженні в localStorage:', error);
		}
	},

	get: (key) => {
		try {
			const item = localStorage.getItem(key);
			return item ? JSON.parse(item) : null;
		} catch (error) {
			console.error('Помилка при читанні з localStorage:', error);
			return null;
		}
	},

	remove: (key) => {
		try {
			localStorage.removeItem(key);
		} catch (error) {
			console.error('Помилка при видаленні з localStorage:', error);
		}
	}
};

export function useLocalStorage(key, initialValue) {
	const [storedValue, setStoredValue] = useState(() => {
		try {
			const item = localStorage.getItem(key);
			return item ? JSON.parse(item) : initialValue;
		} catch (error) {
			return initialValue;
		}
	});

	useEffect(() => {
		try {
			localStorage.setItem(key, JSON.stringify(storedValue));
		} catch (error) {
			console.error(error);
		}
	}, [key, storedValue]);

	return [storedValue, setStoredValue];
}

export function useSessionStorage(key, initialValue) {
	const [storedValue, setStoredValue] = useState(() => {
		try {
			const item = sessionStorage.getItem(key);
			return item ? JSON.parse(item) : initialValue;
		} catch (error) {
			return initialValue;
		}
	});

	useEffect(() => {
		try {
			sessionStorage.setItem(key, JSON.stringify(storedValue));
		} catch (error) {
			console.error(error);
		}
	}, [key, storedValue]);

	return [storedValue, setStoredValue];
}